<template>
  <div>
    <div v-if="requestPromise !== null" style="position: relative;">
      <v-alert
        v-if="failure"
        prominent text
        color="deep-orange"
        border="left"
        type="warning"
        icon="mdi-alert-circle"
        class="my-3"
      >
        <v-row class="ma-0">
          <v-col class="grow align-self-center pa-0">
            <template v-if="response">
              <slot name="response-error">{{ getErrorMessageByResponse(response) }}</slot>
            </template>
            <template v-else>
              <slot name="no-response-error">{{ trans('request.errorGeneral') }}</slot>
            </template>
          </v-col>
          <v-col class="shrink pa-0">
            <v-btn v-if="retryAction" fill icon-material="refresh" @click="retryAction"> {{ trans('request.retry') }}</v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <template v-else-if="success || (lastTimeSuccess && !hideContentOnReload)">
        <slot></slot>
      </template>
      <v-overlay :value="showLoadingOverlay" z-index="4" :color="overlayColor" absolute opacity="0.5" style="min-height: 200px;" class="d-flex justify-center align-content-center flex-column text-center">
        <v-progress-circular indeterminate :size="58" color="primary"></v-progress-circular>
        <div class="text--secondary mt-6">{{ loadingText ? loadingText : trans('general.isLoading') }}</div>
      </v-overlay>
    </div>
    <slot v-else-if="alwaysShow"></slot>
  </div>
</template>

<script>

import {MainUtils} from '@/utils/main-utils';
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'RequestState',
  mixins: [
    MainUtils,
    LocaleUtils
  ],
  props: {
    requestPromise: {
      required: true
    },
    retryAction: {
      type: Function
    },
    loadingText: {
      type: String
    },
    hideContentOnReload: {
      type: Boolean,
      default: () => false
    },
    /**
     * @type alwaysShow {boolean} Always show slot content, even if no promise is given
     */
    alwaysShow: {
      type: Boolean,
      default: false
    },

    overlayColor: {
      default: 'white'
    }
  },

  data: () => ({
    success: false,
    failure: false,
    response: null,
    lastTimeSuccess: false,
    showLoadingOverlay: false
  }),

  watch: {
    requestPromise () {
      this.showLoadingOverlay = true;
      this.success = false;
      this.failure = false;

      this.requestPromise.then(response => {
        this.response = response;
        this.success = true;
      });

      this.requestPromise.catch(response => {
        console.warn('Request error', response);
        this.response = response;
        this.failure = true;
      });

      this.requestPromise.finally(() => {
        this.showLoadingOverlay = false;
        this.lastTimeSuccess = this.success;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.no-data-placeholder {
  display: flex;
  flex-flow: column;
  align-items: center;

  i {
    margin-bottom: 0.3rem;
  }
}
</style>
